var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('kst-output',{attrs:{"print-mode":"","field":"AdjNumber","data":_vm.details,"catalog":_vm.Catalog}}),_c('kst-output',{attrs:{"print-mode":"","field":"Date","data":_vm.details,"catalog":_vm.Catalog}}),_c('kst-output',{attrs:{"print-mode":"","field":"WarehouseID","data":_vm.details,"catalog":_vm.Catalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }